import { useTranslation } from "@redotech/redo-i18n";
import type { OrderNumberState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { memo, useMemo, useState } from "react";

export const OrderNumberDetails = memo(function OrderNumberDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<OrderNumberState>) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const tags = useMemo(
    () =>
      state.map((orderNumber) => ({
        text: orderNumber,
        color: "gray" as const,
      })),
    [state],
  );

  return (
    <RedoTagInputField
      delimiters={["newline"]}
      inputValue={inputValue}
      label={t("Order numbers")}
      placeholder={t("Type and press Enter to add order numbers")}
      setInputValue={setInputValue}
      setTags={setState}
      size="sm"
      state={disabled ? "disabled" : "default"}
      tags={tags}
    />
  );
});
